<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="@/assets/imgs/icon_open.png"></div>
      <div class="title">り覧履歴</div>
    </div>
    <div class="body_right_second">
      <div class="body_right_second_scrollbar">
        <history-item v-for="(item,index) in list" :key="index" :data="item"></history-item>
      </div>
    </div>
  </div>
</template>

<script>
import * as json from '@/assets/js/json'
import historyItem from '@/components/historyItem/index'
  export default {
    components: {
      historyItem
    },
    data () {
      return {
        list: []
      }
    },
    created () {
      this.fetch()
    },
    methods: {
      fetch(){
        this.Loading = true
        this.list = this.$store.state.historyList
        this.Loading = false
      }
    }
  }
</script>

<style src="@/pages/homePage/notice/likeNotice/index.css" scoped>
</style>

